"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareArguments = exports.ShareOptions = void 0;
exports.ShareOptions = [
    {
        name: "option",
        type: "string",
        description: "option",
        required: true,
        choices: ["share-app", "share-with-users"],
    },
    {
        name: "users",
        type: "string",
        description: "Enter user emails (separated by commas)",
    },
];
exports.ShareArguments = [];
//# sourceMappingURL=ShareOptions.js.map